var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Transformer } from '@pacem/pacem-core';
import { Point } from '@pacem/pacem-foundation';
import { MeshGeometry } from '../geometry';
import { Point3DConverter } from '../converters';
//namespace Pacem.Drawing3D {
class OBJParser {
    static parse(content) {
        // vertices
        const vertices = [];
        const vParser = /^v((\s+-?[\d\.]+){3})/gm;
        let arr = vParser.exec(content);
        while (arr && arr.length) {
            vertices.push(Point3DConverter.convert(arr[1]));
            arr = vParser.exec(content);
        }
        // uvmap
        const vt = [];
        const tParser = /^vt((\s+-?[\d\.]+){2})/gm;
        arr = tParser.exec(content);
        while (arr && arr.length) {
            vt.push(Point.parse(arr[1]));
            arr = tParser.exec(content);
        }
        // normals
        const vn = [];
        const nParser = /^vn((\s+-?[\d\.]+){3})/gm;
        arr = nParser.exec(content);
        while (arr && arr.length) {
            vn.push(Point3DConverter.convert(arr[1]));
            arr = nParser.exec(content);
        }
        const normals = [];
        const uv = [];
        const positions = [];
        const fParser = /^f((\s+([\d]+\/[\d]+\/[\d]+)){3,})/gm;
        arr = fParser.exec(content);
        while (arr && arr.length) {
            const fjParser = /([\d]+)\/([\d]+)\/([\d]+)/g;
            const face = arr[1];
            let jArr = fjParser.exec(face);
            let jIndex = 0;
            var vIndex0, tIndex0, nIndex0;
            var vIndex, tIndex, nIndex;
            while (jArr && jArr.length) {
                if (jIndex > 2) {
                    // 4+ vertex-face
                    // but mesh only allows triangluar faces
                    // re-add(0)
                    positions.push(vIndex0);
                    uv.push(vt[tIndex0]);
                    normals.push(vn[nIndex0]);
                    // re-add(last)
                    positions.push(vIndex);
                    uv.push(vt[tIndex]);
                    normals.push(vn[nIndex]);
                }
                // OBJ indexes are 1-based
                vIndex = parseInt(jArr[1]) - 1;
                tIndex = parseInt(jArr[2]) - 1;
                nIndex = parseInt(jArr[3]) - 1;
                positions.push(vIndex);
                uv.push(vt[tIndex]);
                normals.push(vn[nIndex]);
                if (jIndex === 0) {
                    vIndex0 = vIndex;
                    tIndex0 = tIndex;
                    nIndex0 = nIndex;
                }
                jIndex++;
                jArr = fjParser.exec(face);
            }
            // loop
            arr = fParser.exec(content);
        }
        // faces
        return new MeshGeometry(vertices, positions, uv, normals);
    }
}
class Parser3D {
    static parseGeometry(content, type) {
        switch (type.toLowerCase()) {
            case 'obj':
                return OBJParser.parse(content);
            default:
                throw new Error(`Type '${type}' is not supported.`);
        }
    }
}
__decorate([
    Transformer('parse3D')
], Parser3D, "parseGeometry", null);
